import React from "react";
import { useSearchParams } from "react-router-dom";
import GenericTabs from "@ui-components/Tabs/GenericTabs";
import { useAppSelector } from "@redux/hooks";
import { RootState } from "@redux/store/store";
import BackboneFilters from "kontrolEdge/components/Backbone/BackboneDetails/BackboneFilters";

const BACKBONE_DETAIL_TABS = [
	{ label: "Connectors Overview", value: "connectors" },
	{ label: "Topology", value: "topology" },
	{ label: "BGP Sessions", value: "bgp" },
	{ label: "Routing Table", value: "routing" },
	// { label: "Policy Rules · Beta", value: "policy" }, << Etapa 2
];

const DEFAULT_TAB = "connectors";

const TABS_WITH_VRF_FILTER = new Set([
	"connectors",
	"topology",
	"bgp",
	"routing",
]);

export default function BackboneDetailsTabs() {
	const [searchParams, setSearchParams] = useSearchParams();
	const tab = searchParams.get("tab") || DEFAULT_TAB;
	const activeTab = BACKBONE_DETAIL_TABS.some((t) => t.value === tab)
		? tab
		: DEFAULT_TAB;

	const { vrfs, connectorTypes, bgpStatusCounts } = useAppSelector(
		(state: RootState) => state.backboneDetails
	);
	const hasBgpStatusOptions =
		(bgpStatusCounts.up ?? 0) + (bgpStatusCounts.down ?? 0) > 0;
	const hasFilterableData =
		vrfs.length > 0 || connectorTypes.length > 0 || hasBgpStatusOptions;
	const showVrfFilters = hasFilterableData && TABS_WITH_VRF_FILTER.has(activeTab);

	const onTabChange = (value: string) => {
		setSearchParams(
			(prev) => {
				const next = new URLSearchParams(prev);
				next.set("tab", value);
				return next;
			},
			{ replace: true }
		);
	};

	return (
		<div className="mt-1 w-full">
			{/* Mobile: full width so the horizontal scroll has enough room to
			    show all the tabs. sm+: half width as before. */}
			<div className="w-full sm:w-1/2">
				<GenericTabs
					tabs={BACKBONE_DETAIL_TABS}
					activeTab={activeTab}
					onTabChange={onTabChange}
					size="sm"
				/>
			</div>
			{showVrfFilters && <BackboneFilters />}
		</div>
	);
}
